<template>
<div>
    <base-header v-once pageName="영업활동계획서" :popup="true"></base-header>

    <section id="wrap">
        <h2 class="bsnsAcpln-mem" v-if="pstnTyp !== 'COG01'"><em v-bind:class="pstnChk()"></em><span>{{userName}}</span><i>{{userId}}</i></h2>
        <h3 class="bsnsAcpln-tit">{{planYr}}년 {{planMn}}월 영업활동계획</h3>
        <div class="bsnsAcpln-view">
            <div>
                <h6 v-if="pstnTyp === 'COG01'">지국 실적 목표</h6>
                <h6 v-else>개인 실적 목표</h6>
                <span><em>{{amtSum | numFormat}}<template v-if="pstnTyp === 'COG01' && amtSum != orcpAmtSum">({{orcpAmtSum | numFormat}})</template></em>만원</span>
                <ul>
                    <li v-for="amt in amtList" v-bind:key="amt.cateCd">
                        <strong>{{amt.cateNm}}</strong>
                        <span><em>{{amt.goalAmt | numFormat}}<template v-if="pstnTyp === 'COG01' && amt.goalAmt != amt.orcpGoalAmt">({{amt.orcpGoalAmt | numFormat}})</template></em>만원</span>
                    </li>
                </ul>
            </div>
            <div>
                <h6>활동 목표</h6>
                <ul class="flex">
                    <li v-for="act in activityItems" v-bind:key="act.cateCd">
                        <strong>{{act.cateNm}}</strong>
                        <span><em>{{act.goalCscnt | numFormat}}</em>건</span>
                    </li>
                </ul>
            </div>
            <div v-if="counselItems.length">
                <h6>상담 목표</h6>
                <ul class="flex">
                    <li v-for="act in counselItems" v-bind:key="act.cateCd">
                        <strong>{{act.cateNm}}</strong>
                        <span><em>{{act.goalCscnt | numFormat}}</em>건</span>
                    </li>
                </ul>
            </div>
        </div>
        <dl class="bsnsAcpln-view" v-if="periodRows.length">
            <dt>구간 마감</dt>
            <dd>
                <p>단위(만원)</p>
                <table>
                    <thead>
                        <tr>
                            <th>마감</th>
                            <th>목표</th>
                            <th v-for="amt in amtList" v-bind:key="'th-'+amt.cateCd">{{amt.cateNm}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in periodRows" v-bind:key="row.label">
                            <td>{{row.label}}</td>
                            <td>{{Math.floor(row.ratio*100)+'%'}}</td>
                            <td v-for="amt in amtList" v-bind:key="row.label+'-'+amt.cateCd">{{Math.floor(Number(amt.goalAmt||0)*row.ratio) | numFormat}}</td>
                        </tr>
                    </tbody>
                </table>
            </dd>
        </dl>
        <dl class="bsnsAcpln-view" v-if="pstnTyp !== 'COG01'">
            <dt>기타 보고사항</dt>
            <dd class="memo">{{memo}}</dd>
        </dl>
    </section>
    <div class="btnWrap">
        <button type="button" class="red" @click="regBsnPlan"
            v-if="planYr === endYr && planMn === endMn && pstnTyp != 'COG01'">수정</button>
    </div>
</div>
</template>

<script>
// 영업활동계획(신규) - 본인 계획 상세 (읽기 전용).
// 기존 /mypage/bsnPlnDetail (BsnPlnDetail.vue) 과 동일한 흐름 — 목록에서 항목을 누르면 이 화면이 뜨고,
// "수정 가능 기간"일 때만 하단 수정 버튼이 보인다. 기존 파일은 전혀 건드리지 않는다.

// 활동목표(BPG) 중 "상담 목표" 섹션에 들어갈 카테고리 코드 — 기존상담(BPG04), 신규상담(BPG05).
var COUNSEL_CATE_CDS = ['BPG04', 'BPG05'];

export default {
  name: "BsnPlan2Detail",

  data() {
    return {
      sqno: this.$route.query.sqno,
      userName: '',
      userId: '',
      pstn: '',
      // 지국장(COG01)은 개인 sqno 가 없는 집계 행이라, 목록에서 연/월을 그대로 넘겨받는다.
      planYr: this.$route.query.planYr || '',
      planMn: this.$route.query.planMn || '',
      memo: '',
      amtList: [],
      actList: [],
      periodRows: [],

      // 수정 가능 기간 판단용 (기존 BsnPlnDetail.vue 와 동일한 방식)
      endDt: '',   // 1구간 마감일
      endDt2: '',  // 1구간 마감일 + 1
      endYr: '',   // 오늘 연도
      endMn: '',   // 오늘 월
      endDy: '',   // 오늘 일

      pstnTyp: this.$store.getters.orgnzPstn
    };
  },

  computed: {
    amtSum: function() {
      return this.amtList.reduce(function(sum, amt) {
        return sum + Number(amt.goalAmt || 0);
      }, 0);
    },
    // 지국장(COG01) 전용 — 소속 조직원들이 최초 확정한 값의 합계. 이후 누가 수정하면
    // amtSum 과 달라지므로, 그 경우에만 "합계(원본합계)" 형태로 같이 보여준다.
    orcpAmtSum: function() {
      return this.amtList.reduce(function(sum, amt) {
        return sum + Number(amt.orcpGoalAmt || 0);
      }, 0);
    },
    counselItems: function() {
      return this.actList.filter(function(act) { return COUNSEL_CATE_CDS.indexOf(act.cateCd) !== -1; });
    },
    activityItems: function() {
      return this.actList.filter(function(act) { return COUNSEL_CATE_CDS.indexOf(act.cateCd) === -1; });
    }
  },

  methods: {
    regBsnPlan: function() {
      // 기존 BsnPlnDetail.vue 의 가드와 동일: 오늘이 1구간 마감일 ~ 마감일+1 사이여야 수정 가능
      var today = this.endYr + this.endMn + this.endDy;
      if (!this.endDt || !this.endDt2 || this.endDt2 < today || this.endDt > today) {
        alert("수정 가능 기간이 아닙니다.");
        return false;
      }
      this.$router.push('/bsnplan2/reg?sqno=' + this.sqno + '&planYr=' + this.planYr + '&planMn=' + this.planMn);
    },

    pstnChk: function() {
      if (this.pstn == 'COG02') return 'epLv1';
      if (this.pstn == 'COGA2') return 'epLvA1';
      if (this.pstn == 'COG03') return 'epLv2';
      if (this.pstn == 'COG04') return 'epLv3';
      if (this.pstn == 'COG05') return 'epLv4';
      return '';
    }
  },

  filters: {
    numFormat: function(num) {
      if (num == null || num == 0) return 0;
      var n = num + '';
      var reg = /(^[+-]?\d+)(\d{3})/;
      while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');
      return n;
    }
  },

  created: function() {
    var now = new Date();
    this.endYr = now.getFullYear() + '';
    this.endMn = ((now.getMonth() + 1) < 10 ? '0' : '') + (now.getMonth() + 1);
    this.endDy = ("00" + now.getDate()).slice(-2);

    // 지국장(COG01): sqno 없이 planYr/planMn 만으로 소속 조직원 전체 집계를 조회한다.
    // 그 외: sqno 기준 개인 계획 상세.
    if (this.pstnTyp !== 'COG01' && !this.sqno) return;

    var that = this;
    var formParams = this.pstnTyp === 'COG01'
      ? { planYr: this.planYr, planMn: this.planMn }
      : { sqno: this.sqno };

    this.$api.bsnPlan2
      .form(formParams)
      .then(function(data) {
        if (data) {
          that.userName = data.userName;
          that.userId = data.userId;
          that.pstn = data.pstn;
          if (that.pstnTyp !== 'COG01') {
            that.planYr = data.planYr;
            that.planMn = data.planMn;
          }
          that.memo = data.memo;
          that.amtList = data.amtList || [];
          that.actList = data.actList || [];
          that.endDt = data.endDt || '';
          that.endDt2 = data.endDt2 || '';
        }
      })
      .catch(function(error) {
        alert(error.rtMsg);
      });

    // 구간 마감 자동비율표 — 기존 화면과 동일하게 TBL_COMN_CD(PREN_CD='CSC') 기반 비율을 재사용
    this.$api.mypage
      .bsnPlnInfo({})
      .then(function(data) {
        if (data && data.period && data.period.length >= 5) {
          var labels = ['1영업일', '1구간', '2구간', '3구간', '월마감'];
          that.periodRows = data.period.slice(0, 5).map(function(p, i) {
            return { label: labels[i], ratio: Number(p.cdVl1) };
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>
